module.exports = __webpack_public_path__ + "media/images/prizes/left_points-fb579867fb018d3ab8c56ef4ee8f2c72.svg";